export default __webpack_public_path__ + "assets/media/13-1-1485162-1547463769470.jpg";